export var props = {
  value: {
    type: String,
    required: true
  },
  keepChildAlive: {
    type: Boolean,
    required: false
  },
  tabsBodyStyle: {
    type: Object,
    required: false
  },
  tabsHeaderStyle: {
    type: Object,
    required: false
  },
  id: {
    type: String,
    required: false
  },
  onDisabledTabClick: {
    type: Function,
    required: false,
    default: () => () => {}
  }
};